import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadTaskService {





  url = environment.serverAPI9 + "/api/sequences";

  url1 = environment.serverAPI10 + "/api";

  url2 = environment.serverAPI10 + "/api";


  constructor(private http: HttpClient) { }

  searchTaskTabs(query: string, page: number, size: number, sort: string, additionalQuery: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

      additionalQuery: additionalQuery != null ? additionalQuery : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/lead/task/condition${queryParams}`, requestBody);
  }


  getSequenceTaskCount(query: string, groupBy: string, additionalQuery: any): Observable<any> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      groupBy: groupBy ?? null,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };

    return this.http.post<Response[]>(`${this.url2}/sequenceTaskCount/condition`, requestBody);
  }

  getSequenceActionTypeTaskSummary(query: string, groupBy: string, additionalQuery: any): Observable<any> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      groupBy: groupBy ?? null,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };

    return this.http.post<Response[]>(`${this.url2}/sequenceActionTypeTaskSummary/condition`, requestBody);
  }

  getSequenceActionTypeTaskSummaryNew(query: string, groupBy: string, additionalQuery: any): Observable<any> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      groupBy: groupBy ?? null,
      additionalQuery: additionalQuery != null ? additionalQuery : null,
    };

    return this.http.post<any>(`${this.url2}/sequenceActionTypeTaskSummary/condition`, requestBody);
  }


  updateTask(taskSaveObject: any, taskId: any) {
    const params = {
      taskId,
    };
    return this.http.post(`${this.url2}/task/update-status`, taskSaveObject, { params });
  }

  skipTask(taskId: any, sequenceId: any, stepId: any, userId: any) {
    const params = {
      taskId,
      sequenceId,
      stepId,
      userId
    };
    return this.http.post(`${this.url2}/task/skip`, {}, { params });
  }

  searchTaskTabsNew1(query: string, page: number, size: number, sort: string, additionalQuery: string, groupBy: any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "groupBy": groupBy,
      additionalQuery: additionalQuery != null ? additionalQuery : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/sequencesLeadTask/condition${queryParams}`, requestBody);
  }

  playTask(selectedTasks: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, selectedTasks);
  }

   	deleteByLeadId(id: any): Observable<Object> {
		return this.http.delete(`${this.url2}/sequence/lead/${id}`);
	}

}
